import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CalendarIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M16.6667 2.5h-.8333V.833332h-1.6667V2.5H5.83335V.833332H4.16669V2.5h-.83334c-.91666 0-1.66666.75-1.66666 1.66667V17.5c0 .9167.75 1.6667 1.66666 1.6667H16.6667c.9167 0 1.6667-.75 1.6667-1.6667V4.16667c0-.91667-.75-1.66667-1.6667-1.66667Zm0 15H3.33335V6.66667H16.6667V17.5Z" />
  </Icon>
);

export default memo(CalendarIcon);
